import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as hookActions from 'checkout/actions/hooks';
import { toDecimals } from '../../helpers/currency';

class Impact extends Component {
  constructor(props) {
    super(props);
    if(props.config.uuid){
      this.props.addReservationCompleteHook(this.onReservationComplete);
    }
  }

  componentDidMount() {
    this.loadImpactScript();
  }

  loadImpactScript = () => {
    if (this.props.config.uuid && !window.ire) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = `https://utt.impactcdn.com/${this.props.config.uuid}.js`;
      script.onload = () => {
        this.identifyUser();
      };
      document.head.appendChild(script);
    }
  }

  identifyUser = () => {
    const customer = this.getCustomer();
    window.ire("identify", customer);
  };

  render() {
    return null;
  }

  getOrCreateCustomProfileId =() => {
    const key = 'impact_custom_profile_id';
    let id = localStorage.getItem(key);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(key, id);
    }
    return id;
  }

  getCustomer = () => {
    return {
      customerId: this.props.member.id, 
      customerEmail: '', 
      customProfileId: this.getOrCreateCustomProfileId(),
    };
  };


  groupTickets = () => {
    return this.props.tickets.reduce((acc, ticket) => {
      if (!acc[ticket.price_level_id]) {
        acc[ticket.price_level_id] = {
          subTotal: 0,
          category: ticket.event_name,
          sku: ticket.price_level_id,
          quantity: 0,
          name: ticket.price_level_name
        };
      }
      
      acc[ticket.price_level_id].subTotal += toDecimals({ amount: ticket.price_level_cost.amount, currency: this.props.currency });
      acc[ticket.price_level_id].quantity += 1;
  
      return acc;
    }, {});
  }

  groupProduct = () => {
    return this.props.productSales.reduce((acc, product) => {
      if (!acc[product.configuration_id]) {
        acc[product.configuration_id] = {
          subTotal: 0,
          category: product.event_name,
          sku: product.configuration_id,
          quantity: 0,
          name: product.display_name
        };
      }
      
      acc[product.configuration_id].subTotal += toDecimals({ amount: product.cost.amount, currency: this.props.currency });
      acc[product.configuration_id].quantity += 1;
  
      return acc;
    }, {});
  }
  

  getOrderItems = () => {
    return Object.values(this.groupTickets()).concat(Object.values(this.groupProduct()));
  }

  getOrder = () => {
    return {
        orderId: this.props.reservation_id,
        customProfileId: this.getOrCreateCustomProfileId(),
        customerId: this.props.member.id,
        customerEmail: '', //PII
        customerStatus: this.props.member.orderCount <= 1 ? 'New' : 'Existing',
        currencyCode: this.props.currency,
        orderPromoCode: this.props.coupon.code,
        orderDiscount: this.props.coupon.couponData 
          ? toDecimals({amount: this.props.coupon.couponData.reduce((sum, item) => sum + item.amount, 0), currency: this.props.currency})
          : 0,
        items: this.getOrderItems(),
      }
  };

  onReservationComplete = () => {
    if (window.ire) {
      this.identifyUser();

      const key = 'impact_onReservationComplete_' + this.props.confirmationNumber;
      const sent = sessionStorage.getItem(key);
      if (sent != '1') {
        window.ire("trackConversion", this.props.config.eventID, this.getOrder(),{ verifySiteDefinitionMatch: true });
        sessionStorage.setItem(key, '1');
      }
    }
  };
}

const mapStateToProps = (state) => {
  return {
    currency: state.reservation.currency,
    reservation_id: state.reservation.reservation_id,
    tickets: state.tickets.tickets,
    productSales: state.productSales.products,
    member: state.member,
    coupon: state.coupon,
  };
};

const mapDispatchToProps = (dispatch) => {
  const actions = {};
  Object.keys(hookActions).forEach((hookActionName) => {
    actions[hookActionName] = hookActions[hookActionName];
  });
  return bindActionCreators(actions, dispatch);
};

Impact.propTypes = {
  config: PropTypes.object.isRequired,
  addReservationCompleteHook: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Impact);  
